import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgPieChart = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 64 64",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M47.9898 59.7117C43.7391 62.1659 38.9808 63.6093 34.083 63.9303C29.1853 64.2513 24.2793 63.4413 19.7446 61.563C15.2099 59.6847 11.1682 56.7884 7.9319 53.0982C4.69564 49.4079 2.35167 45.0226 1.08131 40.2816C-0.189043 35.5406 -0.351735 30.5708 0.605824 25.7569C1.56338 20.9429 3.61553 16.4137 6.6035 12.5197C9.59147 8.62571 13.4352 5.47125 17.8373 3.30037C22.2394 1.12949 27.0819 0.000381411 31.9902 0.00038147V18.0932C29.8571 18.0932 27.7526 18.5839 25.8395 19.5273C23.9264 20.4708 22.256 21.8416 20.9575 23.5339C19.659 25.2262 18.7671 27.1945 18.351 29.2866C17.9348 31.3787 18.0055 33.5385 18.5576 35.5988C19.1097 37.6592 20.1284 39.565 21.5348 41.1687C22.9412 42.7725 24.6977 44.0312 26.6684 44.8475C28.6391 45.6637 30.7712 46.0157 32.8997 45.8762C35.0282 45.7367 37.0961 45.1094 38.9434 44.0429L47.9898 59.7117Z",
			fill: "#60A5FA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M31.9902 0.00038147C36.1924 0.00038152 40.3534 0.828066 44.2358 2.43618C48.1181 4.04429 51.6456 6.40134 54.6171 9.37274C57.5885 12.3441 59.9455 15.8717 61.5536 19.754C63.1617 23.6364 63.9894 27.7974 63.9894 31.9996L45.8966 31.9996C45.8966 30.1734 45.5369 28.3651 44.838 26.6778C44.1392 24.9906 43.1148 23.4576 41.8235 22.1663C40.5322 20.875 38.9991 19.8506 37.3119 19.1518C35.6247 18.4529 33.8164 18.0932 31.9902 18.0932V0.00038147Z",
			fill: "#E3EBFD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M63.9894 31.9996C63.9894 37.6166 62.5108 43.1347 59.7023 47.9992C56.8938 52.8637 52.8543 56.9032 47.9898 59.7117L38.9434 44.0429C41.0574 42.8224 42.8129 41.0668 44.0335 38.9528C45.254 36.8388 45.8966 34.4407 45.8966 31.9996L63.9894 31.9996Z",
			fill: "#BFDBFE"
		})
	]
});
export default SvgPieChart;
